import styled from 'styled-components'
import { BaseContainer } from '../../styles/styles'

export const ArticleListContainer = styled(BaseContainer)`
    flex-wrap: wrap;
    padding: 1em;
`
export const Title = styled.div`
    flex: 1 100%;
`
